import axios from "axios"
import moment from "moment-timezone"

//TODO: add in options / filter for tracking loads

const fetchTrackingLoads = async () => {
  //TODO: These should come from the options / filter
  const pickup_date = moment.tz("America/Chicago").subtract(7, 'days').format('YYYY-MM-DD')
  const params = {
    "with": 'equipment_type,stops,driver',
    "status[in]": "COVERED,DISPATCHED,PICKUP,LOADED,CONSIGNEE,DELIVERED",
    "pickup_date[gte]": pickup_date,
    "page_size": 2000
  }
  const resp= await  axios({
    method: "get",
    url: `/api/v2/loads`,
    params
  })
  return (resp?.data?.results?.length) ? resp.data.results : []

}

const fetchTrackingLoadByPro = async (pro) => {
    const params = {
      "include": 'equipment_type',
  }
  const resp = await axios({
    method: "get",
    url: `/api/v2/load/${pro}`,
    params
  })

  return (resp?.data) ? resp.data : null
}

export {
  fetchTrackingLoads,
  fetchTrackingLoadByPro
}
